// Names for people the portal only knows by sign-in address (D104).

/**
 * A readable name from a sign-in address, used until the person's own profile is known:
 * "sara.ali@smc.me" → "Sara Ali". Never shows the address itself on a document.
 */
export function personName(upn: string): string {
  const at = upn.indexOf('@');
  if (at <= 0) return upn;
  const words = upn
    .slice(0, at)
    .split(/[._-]+/)
    .filter((w) => w && !/^\d+$/.test(w));
  if (!words.length) return upn;
  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
}

/** Who signed a document: name and job title (title '' when not known). */
export interface Signatory {
  name: string;
  title: string;
}
